import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { CustomerGroupListModel } from "../types/CustomerGroup";
import { removeEmptyKeysFromFilters } from "src/utils/object";

export const RQ_CUSTOMER_GROUP_LIST_KEY = "CUSTOMER_GROUP_LIST_KEY";

export type CustomerGroupListResponse = PagedResponse<CustomerGroupListModel[]>;

export type CustomerGroupListFilters = {
    id?: string;
    name?: string;
};

export const useCustomerGroupList = (
    page: number,
    perPage: number,
    searchFilters: CustomerGroupListFilters
) => {
    const filters = removeEmptyKeysFromFilters(searchFilters);

    return useQuery({
        queryKey: [RQ_CUSTOMER_GROUP_LIST_KEY, page, perPage, filters],
        queryFn: async (): Promise<CustomerGroupListResponse | null> => {
            const res = await axiosCompanyInstance.get(`group`, {
                params: { ...filters, page: page + 1, perPage },
            });

            return res?.data || null;
        },
    });
};
